export default "__VITE_ASSET__dd2f4fe7__"